$(document).on("turbolinks:load", function () {
  let $followSwitch = $(".js-shop-email-switch")

  $followSwitch.on("change", function () {
    let $this = $(this)
    let $followId = $this.data("follow-id")
    let $text = $(`.js-follow_td-text-${$followId}`)
    let $link = $(`.js-creator_follow_link-${$followId}`)

    $.ajax({
      type: "PATCH",
      data: {
        shop_follow: { active: $this.is(":checked") ? "true" : "false" },
      },
      url: `/account/privacy-center/shop_follows/${$followId}`,
      dataType: "json",
      success: () => {
        $text.toggleClass("text-muted")
        $link.toggleClass("link-muted")
      },
    })
  })
})
